var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "tablecell_dialog",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "表示項目設定",
        top: "5vh",
        visible: _vm.show,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c("div", { staticClass: "flex_space flex_center_align mb16" }, [
        _c(
          "div",
          { staticClass: "new_h_date flex_center_align" },
          [
            _c("svg-icon", {
              staticClass: "ml2",
              attrs: { "icon-class": "tryangle_down" },
            }),
            _c("span", [
              _vm._v(
                " チェックボックスで表示の切り替え、ドラッグ＆ドロップで表示順を入れ替えられます "
              ),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "vab-row",
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.checkList,
                callback: function ($$v) {
                  _vm.checkList = $$v
                },
                expression: "checkList",
              },
            },
            [
              _c(
                "vab-draggable",
                {
                  staticClass: "drag_item",
                  attrs: { list: _vm.columns, move: _vm.onMove },
                },
                _vm._l(_vm.columns, function (item, index) {
                  return _c(
                    "vab-col",
                    {
                      key: item + index,
                      staticClass: "col_padding",
                      class: [item.disableCheck ? "undraggable" : ""],
                      attrs: { span: 8 },
                    },
                    [
                      item.type != "actions" &&
                      !_vm.$baseLodash.has(item, "fixed")
                        ? _c(
                            "div",
                            { staticClass: "flex_start flex_center_align mb8" },
                            [
                              _c("div", { staticClass: "code" }, [
                                _vm._v(
                                  _vm._s(index + 1 - _vm.disabledNum) + "."
                                ),
                              ]),
                              _c("div", { staticClass: "item_box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "inner_box flex_space flex_center_align",
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          disabled: item.disableCheck === true,
                                          label: item.label,
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item.label) + " ")]
                                    ),
                                    _c("svg-icon", {
                                      staticClass: "svg_move_line",
                                      attrs: { "icon-class": "move_line" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c(
                "div",
                {
                  staticClass: "clear_box",
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("デフォルトに戻す")]
              ),
              _c(
                "el-button",
                { staticClass: "cancel ml8", on: { click: _vm.close } },
                [_vm._v("キャンセル")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "changebtn",
                  attrs: { icon: "el-icon-check" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" 確定 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }